// src/pages/CreateBulkInvoice.tsx
import React, { useEffect, useState } from "react";
import { getVehicles, createInvoice } from "../services/api";
import { useNavigate } from "react-router-dom";

const CreateBulkInvoice: React.FC = () => {
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState<number[]>([]);
  const [bulkAmount, setBulkAmount] = useState<number | "">("");
  const [description, setDescription] = useState<string>("Bulk Invoice");
  const navigate = useNavigate();

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    const data = await getVehicles();
    setVehicles(data);
  };

  const handleSelect = (id: number) => {
    setSelectedVehicleIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    if (!bulkAmount) return alert("Enter invoice amount");
    if (selectedVehicleIds.length === 0) return alert("Select at least one vehicle");
    if (!window.confirm(`Create invoice of ₹${bulkAmount} for ${selectedVehicleIds.length} vehicles?`)) return;

    try {
      const promises = selectedVehicleIds.map((vid) =>
        createInvoice({ vehicleId: vid, amount: bulkAmount, description })
      );
      await Promise.all(promises);
      alert("Bulk invoices created successfully!");
      navigate("/invoices");
    } catch (error: any) {
      alert("Error creating invoices: " + error.message);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Create Bulk Invoices</h1>
      <input
        type="number"
        placeholder="Invoice Amount"
        value={bulkAmount}
        onChange={(e) => setBulkAmount(Number(e.target.value))}
        className="border p-2 rounded mb-4 w-1/4"
      />
      <div className="grid grid-cols-3 gap-2 max-h-96 overflow-y-auto border p-2 mb-4">
        {vehicles.map((v) => (
          <label key={v.id} className="flex items-center gap-2 border p-2 rounded">
            <input
              type="checkbox"
              checked={selectedVehicleIds.includes(v.id)}
              onChange={() => handleSelect(v.id)}
            />
            {v.vehicleNo} - {v.ownerName}
          </label>
        ))}
      </div>
      <button
        className="bg-green-600 text-white px-4 py-2 rounded"
        onClick={handleSubmit}
      >
        Create Bulk Invoices
      </button>
    </div>
  );
};

export default CreateBulkInvoice;
